import { Container } from "./container";
function Inject() {
    return function (target, key) {
        var type = Reflect.getMetadata("design:type", target, key);
        Object.defineProperty(target, key, {
            get: function () { return Container.get(type); },
            enumerable: false,
            configurable: false
        });
    };
}
export { Inject };
//# sourceMappingURL=inject.js.map